import { render, staticRenderFns } from "./CedulaErrada.vue?vue&type=template&id=48970a7a&scoped=true"
import script from "./CedulaErrada.vue?vue&type=script&lang=js"
export * from "./CedulaErrada.vue?vue&type=script&lang=js"
import style0 from "./CedulaErrada.vue?vue&type=style&index=0&id=48970a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48970a7a",
  null
  
)

export default component.exports